module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaKriminatlity-d980d395d1b25eb50a6aa888d6be86a2.svg";